import { api } from "../api";

// ================================================================
// Types (совпадают с alfin-api/src/modules/swap-providers/*)
// ================================================================

export interface SwapPair {
  id: string;
  from: { currency: string; network: string };
  to: { currency: string; network: string };
  min_amount: string | null;
  max_amount: string | null;
  markup_bps: number;
  slippage_bps: number;
  sort_order: number;
}

export interface SwapQuote {
  pair_id: string;
  sell_currency: string;
  sell_network: string;
  sell_amount: string;
  buy_currency: string;
  buy_network: string;
  buy_amount: string;
  rate: string;
  raw_expected_output: string;
  fees: {
    liquidity?: string;
    outbound?: string;
    network?: string;
    total?: string;
  };
  time_estimate_sec: number | null;
  route_id: string;
  expires_at: string;
}

export interface SwapExecuteResult {
  order_id: string;
  swap_id: string;
  inbound_address: string;
  destination_address: string;
  memo: string | null;
  status: string;
}

export interface SwapOrder {
  id: string;
  status: string;
  sell_currency: string | null;
  buy_currency: string | null;
  sell_amount: string | null;
  buy_amount: string | null;
  swap_id: string | null;
  inbound_address: string | null;
  destination_address: string | null;
  created_at: string;
  completed_at: string | null;
}

// ================================================================
// API calls
// ================================================================

export async function listSwapPairs(): Promise<SwapPair[]> {
  const { data } = await api.get<SwapPair[]>("/me/swap/pairs");
  return data;
}

export async function getSwapQuote(
  pairId: string,
  sellAmount: string,
): Promise<SwapQuote> {
  const { data } = await api.post<SwapQuote>("/me/swap/quote", {
    pairId,
    sellAmount,
  });
  return data;
}

export async function executeSwap(payload: {
  pairId: string;
  routeId: string;
  sellAmount: string;
  minBuyAmount?: string;
}): Promise<SwapExecuteResult> {
  const { data } = await api.post<SwapExecuteResult>(
    "/me/swap/execute",
    payload,
  );
  return data;
}

export async function listSwapOrders(limit = 50): Promise<SwapOrder[]> {
  const { data } = await api.get<SwapOrder[]>(`/me/swap/orders?limit=${limit}`);
  return data;
}
